<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4405pB/tc-custom/9781455608805.jpg?1728259236245" alt="This image is the cover for the book Metairie"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Metairie
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A surprising journey through the history and growth of this large city neighboring New Orleans.</b></p><p> While New Orleans is recognized the world over for the French Quarter and Mardi Gras, Metairie, a suburb of New Orleans, is not as well known. But Metairie has a rich history all its own. What was described two centuries ago as “a tongue of land to lend pasturage” has become the second largest unincorporated city in the nation. </p><p> The explorer La Salle noticed the river bend that is now Metairie when he descended and ascended the Mississippi River in the spring of 1682. Almost simultaneously with the founding of New Orleans in 1718, John Law’s Company of the West began granting land to European investors and to a handful of Canadians struggling to survive along the Gulf Coast. The settlers helped feed the city, provided it with critical building materials, and enhanced its value as a port. </p><p> As with many colonial frontiers throughout the history of the world, missionaries stood in the vanguard of Metairie’s evolution. French and Spanish friars, then European priests, and finally native clergy provided leadership and stability as a progressive community began to emerge from the marsh and swamp. This book tells the story of this oft-overlooked Louisiana city. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Henry C. Bezou
      </h2>
      
      <p class="authorDescription body article">A native New Orleanian, Monsignor Henry C. Bezou was ordained to the priesthood in 1938 at St. Louis Cathedral. Among his various ministries, he served as pastor of St. Francis Xavier, in the heart of Old Metairie, from 1967 to 1983. He died August 15, 1989.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?56ef94fb